import httpClient from '../axios/index';

class authService {
  test() {
    return httpClient.get('api/account/test');
  }

  userLogin(data) {
    return httpClient.post('api/account/checkUserAuth', data);
  }

  adminLogin(data) {
    return httpClient.post('api/account/checkAdminAuth', data);
  }

  ssoLogin(data) {
    return httpClient.post('api/account/ssoAdminAuth', data);
  }
  googleLogin(data) {
    console.log({ data });
    return httpClient.post('https://apiv2.selfservice3.appnext.com/api/account/googleAuth', data);
    // return httpClient.post('api/account/googleAuth', data);
  }
}

export default new authService();
